import { caption, Header5, text1 } from '@ardoq/typography';
import { colors, s16, s8, shadowM } from '@ardoq/design-tokens';
import { Box, FlexBox } from '@ardoq/layout';
import { type I18nLocale, t } from '@ardoq/i18n';
import styled from 'styled-components';

export function Popover({
  i18nLocale,
  preview,
  count,
  title,
}: {
  i18nLocale: I18nLocale;
  title: string;
  preview: string[];
  count: number;
}) {
  return (
    <PreviewContainer paddingY="medium">
      <Box paddingX="medium">
        <Header5 color="textSubtle">{title}</Header5>
      </Box>
      <PreviewList>
        {preview.map((label, i) => (
          <Box key={i}>{label}</Box>
        ))}
      </PreviewList>
      {preview.length < count && (
        <Footer
          paddingX="medium"
          paddingTop="medium"
          backgroundColor="bgDefault"
          position="relative"
        >
          {t(
            i18nLocale,
            'integrations:popover.previewingOf',
            { shown: preview.length, count },
            'Previewing {{shown}} of {{count}}'
          )}
        </Footer>
      )}
    </PreviewContainer>
  );
}
const Footer = styled(Box)`
  ${caption}
  border-top: 1px solid ${colors.borderSubtle};
  color: ${colors.textSubtle};
`;

const PreviewList = styled(FlexBox).attrs({
  flexDirection: 'column',
  gap: 'medium',
  paddingX: 'medium',
})`
  ${text1}
  max-height: 19rem;
  overflow-y: auto;
`;

// We can't change padding on the popover so we need to add negative margin
const PreviewContainer = styled(FlexBox).attrs({
  flexDirection: 'column',
  gap: 'medium',
  backgroundColor: 'bgDefault',
  borderRadius: 'small',
  position: 'relative',
})`
  color: ${colors.textDefault};
  white-space: nowrap;
  box-shadow: ${shadowM};
  &::before {
    content: '';
    position: absolute;
    top: ${s16};
    left: -${s8};
    width: 0;
    height: 0;
    border-top: ${s16} solid ${colors.bgDefault};
    border-right: ${s16} solid transparent;
    border-bottom: 0 solid transparent;
    border-left: 0 solid transparent;
    transform: rotate(-45deg);
    box-shadow:
      4px 3px 0px 0px rgb(255, 255, 255),
      0px 4px 0 0 rgb(255, 255, 255),
      -4px 0px 8px -2px rgba(0, 0, 0, 0.2);
  }
`;
